export default __webpack_public_path__ + "static/media/provesional_restoration_lower_24_2@2x.4b9c86cf.png";